import { render, staticRenderFns } from "./middleBlock.vue?vue&type=template&id=c1940086&"
import script from "./middleBlock.vue?vue&type=script&lang=js&"
export * from "./middleBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports